<template>
  <v-container class="fill-height pa-0 ma-0 managing fluid" id="managing">
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-layout row>
        <v-flex lg3 class="white">
            <all-msgks></all-msgks>
        </v-flex>
        <v-flex lg9>
            <msgk-window></msgk-window>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout column>
        <v-flex sm12 class="white" v-if="showSidebar">
            <all-msgks></all-msgks>
        </v-flex>
        <v-flex sm12 v-if="showWindow">
            <msgk-window></msgk-window>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>
<script>
import AllMsgks from './AllMsgks'
import MsgkWindow from './MsgkWindow'
export default {
  components: {
    AllMsgks,
    MsgkWindow
  },
  beforeCreate () {
    if(!(localStorage.getItem("role") &&  (localStorage.getItem("role").toLowerCase() === 'admin' ||
      localStorage.getItem("role").toLowerCase() === 'management' ))){
      this.$router.push(`/chat/messaging`);
    }
  },
  computed: {
    showSidebar () {
      return this.$route.params.uuid === undefined
    },
    showWindow () {
      return this.$route.params.uuid !== undefined
    }
  }
}
</script>
